<template>
  <div :class="$style.container">
    <slot name="default" />
  </div>
</template>

<script>

export default {
  name: 'CollapsibleList',
  props: {
    activeIdx: {
      type: Number,
      default: () => null,
    },
    language: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    this.cachedItems = [...this.$slots.default];
  },
  data() {
    return {
      cachedItems: [],
    };
  },
  watch: {
    activeIdx: {
      immediate: false,
      handler: 'updateItems',
    },
    language: {
      deep: true,
      handler() {
        this.updateItems(this.activeIdx);
      },
    },
  },
  methods: {
    updateItems(idx) {
      if (this.$validate.isNull(idx)) {
        this.$slots.default = [...this.cachedItems];
        return;
      }

      const itemByIdx = this.$slots.default.find(item => item.key === idx);

      this.$slots.default = [itemByIdx];
    },
  },
};
</script>

<style lang="sass" module>
  .container

    > *
      &:not(:last-child)
        margin-bottom: 10px
</style>
